

















import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeaderSub from "@/components/main-header-sub.vue";
import NavLeftSub from "@/components/nav-left-sub.vue";
import Chufang from "@/components/duijie/chufang/chufang.vue";
@Component({
  components: {
    NavLeftSub,
    MainHeaderSub,
    Chufang,
  },
})
export default class Name extends Vue {
  private get patient() {
    return this.$store.state.patient;
  }
}
